import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Eye } from "lucide-react";
import bookPage1 from "@/assets/book-page-1.png";
import bookPage2 from "@/assets/book-page-2.png";
import bookPage3 from "@/assets/book-page-3.png";
import bookPage4 from "@/assets/book-page-4.png";
import bookPage5 from "@/assets/book-page-5.png";
import bookPage6 from "@/assets/book-page-6.png";
import bookPage7 from "@/assets/book-page-7.png";
import bookPage8 from "@/assets/book-page-8.png";

const PreviewSection = () => {
  const bookPages = [
    { image: bookPage1, title: "Inhaltsverzeichnis & Naturmittel A-Z" },
    { image: bookPage2, title: "Naturmittel D-L" },
    { image: bookPage3, title: "Naturmittel L-U" },
    { image: bookPage4, title: "Naturmittel U-Z & Alantwurzel" },
    { image: bookPage5, title: "Anwendungsgebiete Alantwurzel" },
    { image: bookPage6, title: "Vitamin-B-Komplex" },
    { image: bookPage7, title: "Vitamin B6 & B12 Details" },
    { image: bookPage8, title: "Nährstoffe während der Schwangerschaft" },
  ];

  return (
    <section className="py-16 md:py-24 gradient-hero">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-4 shadow-sm">
            <Eye className="w-5 h-5 text-primary" />
            <span className="text-sm font-semibold text-primary">Blick ins Buch</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground">
            Blick ins Buch
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Überzeugen Sie sich selbst von der Qualität und dem Umfang
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {bookPages.map((page, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="p-2">
                    <div className="group relative overflow-hidden rounded-xl shadow-soft hover:shadow-hover transition-all duration-300 bg-card border border-border/50">
                      <div className="aspect-[9/16] overflow-hidden">
                        <img
                          src={page.image}
                          alt={page.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/95 via-background/80 to-transparent p-4">
                        <p className="text-sm font-medium text-foreground text-center">
                          {page.title}
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-12" />
            <CarouselNext className="hidden md:flex -right-12" />
          </Carousel>
        </div>

        <div className="text-center mt-8 md:mt-12 space-y-2">
          <p className="text-sm md:text-base text-muted-foreground">
            Diese Seiten geben Ihnen nur einen kleinen Einblick in die Fülle an Informationen
          </p>
          <p className="text-xs md:text-sm text-muted-foreground/80">
            Wischen Sie nach links/rechts oder nutzen Sie die Pfeile zum Durchblättern
          </p>
        </div>
      </div>
    </section>
  );
};

export default PreviewSection;
